import { useEffect, useState } from "react";
import { api } from "../api/client";
import type { SupportSummary } from "../api/types";

/** Chamados que aguardam resposta da administração (só para a administração). Atualiza a cada 60 s e quando algo é lido/respondido. */
export function useSupportUnread(enabled: boolean): number {
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!enabled) return;
    let alive = true;
    const load = () =>
      api
        .get<SupportSummary>("/admin/support/summary")
        .then((u) => alive && setN(u.unread_tickets))
        .catch(() => undefined);
    void load();
    const timer = window.setInterval(() => document.visibilityState === "visible" && void load(), 60_000);
    window.addEventListener("eapace:support-unread", load);
    return () => {
      alive = false;
      window.clearInterval(timer);
      window.removeEventListener("eapace:support-unread", load);
    };
  }, [enabled]);
  return n;
}
